<template>
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
                <v-flex xs12 sm6>
                    <div>
                        <v-btn @click="newPlibel" large color="primary">Nueva hoja</v-btn>
                    </div>
                </v-flex>
            </v-layout>
            <br>
            <br>
            <v-layout>
                <v-flex xs12 sm6 offset-sm1>
                    <v-select v-model="isotr112282" :items="this.listIsotr112282" label="Historial" item-text="fecha"
                              return-object required></v-select>
                </v-flex>
            </v-layout>
            <br>
            <v-expansion-panel v-if="this.isotr112282!=null">
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div> 1. Información personal y laboral</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.isotr112282.informacionLaboral"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0">{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==20" class="font-weight-bold">a. Datos de filiación</p>
                                        <p v-if="props.item.tipo==21" class="font-weight-bold">Identificación:
                                            {{$store.state.patient.identification}}</p>
                                        <p v-if="props.item.tipo==22" class="font-weight-bold">Apellidos y nombres: {{$store.state.patient.firstLastName}} {{$store.state.patient.secondLastName}}  {{$store.state.patient.firstName}} {{$store.state.patient.secondName}} </p>

                                        <p v-if="props.item.tipo==23" class="font-weight-bold">Edad:
                                            {{$store.state.patient.age}}</p>
                                        <p v-if="props.item.tipo==24" class="font-weight-bold">Empresa:
                                            {{$store.state.patient.company.name}}</p>
                                        <p v-if="props.item.tipo==25" class="font-weight-bold">Puesto de trabajo:
                                            {{$store.state.patient.jobCompany}}</p>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div> 2. Empuje y tracción de cargas ISO/TR 11228-2</div>
                    </template>
                    <table style="border: 3px black solid;" width="100%">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>
                                    <h1>Empuje y tracción de cargas ISO/TR 11228-2</h1>
                                </b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <table style="border: 3px black solid;" width="100%">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>
                                    <h1>
                                        Preguntas clave
                                        <br/>|
                                        <br/>˅
                                    </h1>
                                </b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <table style="border: 3px black solid;">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#464AD7">
                                <b>
                                    <font color="white">
                                        Identificación del peligro
                                        <br/>Pregunta Clave
                                    </font>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>IDENTIFICACIÓN DEL PELIGRO ERGONÓMICO POR EMPUJE Y TRACCIÓN DE CARGAS</b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>Marque con una “X” la respuesta a cada una de las siguientes condiciones</b>
                            </td>
                        </tr>
                        <tr>
                            <td align="center" bgcolor="#CCCCAA">
                                <b>En el puesto de trabajo hay alguna tarea que presente alguna de las siguientes
                                    condiciones:</b>
                            </td>
                            <td align="center" bgcolor="#CCCCAA">Respuesta</td>
                        </tr>
                        <tr>
                            <td
                                    bgcolor="#FFFFFF"
                            >1. ¿La tarea requiere empujar o arrastrar un objeto manualmente con el cuerpo de pie o
                                caminando?
                            </td>
                            <td>
                                <v-switch v-model="isotr112282.switch1"
                                          :label="`${this.isotr112282.switch1 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td
                                    bgcolor="#FFFFFF"
                            >2. ¿El objeto a empujar o arrastrar tiene ruedas o rodillos (carro, jaula, carretilla,
                                traspalet, etc.) o se desliza sobre una superficie sin ruedas?
                            </td>
                            <td>
                                <v-switch v-model="isotr112282.switch2"
                                          :label="`${this.isotr112282.switch2 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td
                                    bgcolor="#FFFFFF"
                            >3. ¿La tarea de empuje o arrastre se realiza de forma habitual dentro del turno de trabajo
                                (por lo menos una vez en el turno)?
                            </td>
                            <td>
                                <v-switch v-model="isotr112282.switch3"
                                          :label="`${this.isotr112282.switch3 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CF6D6D">
                                <b>Si todas las respuestas son “SI” para todas las condiciones, hay presencia del
                                    peligro por empuje y arrastre de cargas y debe realizarse una evaluación específica
                                    del riesgo.</b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#ABCF6D">
                                <b>Si alguna de las respuestas a las condiciones es “NO”, no hay presencia del peligro
                                    por empuje y arrastre de cargas.</b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <!--Evaluacion rapida-->
                    <table style="border: 3px black solid;" width="100%">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>
                                    <h1>
                                        Evaluación Rápida
                                        <br/>|
                                        <br/>˅
                                    </h1>
                                </b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <table border="1" style="border: 3px black solid;">
                        <tbody>
                        <tr>
                            <td colspan="3" align="center" bgcolor="#464AD7">
                                <b>
                                    <font color="white">
                                        Estimación de riesgo
                                        <br/>"Evaluacion Rápida"
                                    </font>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#608E12">
                                <b>
                                    <center>
                                        Evaluación rápida del riesgo por empuje y tracción manual de cargas.
                                        <br/>
                                        <br/>Preguntas para determinar si el riesgo por empuje y tracción de cargas es
                                        aceptable o está en la Zona VERDE
                                    </center>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td>a</td>
                            <td>¿El empuje y/o tracción manual de cargas se realiza SÓLO con las extremidades superiores
                                (sin movimiento de las piernas) y el peso de la carga es menor o igual a 25 kg?
                            </td>
                            <td>
                                <v-switch v-model="isotr112282.switch4"
                                          :label="`${this.isotr112282.switch4 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>b</td>
                            <td>¿La fuerza requerida en el empuje y/o tracción es menor de moderada (en la Escala de
                                Borg menor a 3)?
                            </td>
                            <td>
                                <v-switch v-model="isotr112282.switch5"
                                          :label="`${this.isotr112282.switch5 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>c</td>
                            <td>¿Alguna de las siguientes condiciones se cumplen durante el empuje y/o tracción?</td>
                            <td>
                                <v-switch v-model="isotr112282.switch6"
                                          :label="`${this.isotr112282.switch6 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <table border="1" width="100%">
                                    <tbody>
                                    <tr>
                                        <td colspan="2">
                                            <center>
                                                <b>Esfuerzo o carga</b>
                                            </center>
                                        </td>
                                        <td colspan="3">
                                            <b>Fuerza de empuje / tracción o peso de la carga a empujar o tirar</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>c.1.</td>
                                        <td>Peso total de la carga</td>
                                        <td>250 Kg</td>
                                        <td>NO, si es MAYOR</td>
                                        <td>SÍ, si es igual o MENOR</td>
                                    </tr>
                                    <tr>
                                        <td>c.2.</td>
                                        <td>Fuerza inicial de empuje &amp; tracción (si es posible medir o estimar)</td>
                                        <td>100 N</td>
                                        <td>NO, si es MAYOR</td>
                                        <td>SÍ, si es igual o MENOR</td>
                                    </tr>
                                    <tr>
                                        <td>c.3.</td>
                                        <td>Fuerza sostenida de empuje / tracción</td>
                                        <td>30 N</td>
                                        <td>NO, si es MAYOR</td>
                                        <td>SÍ, si es igual o MENOR</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#608E12">
                                Si a
                                <b>todas</b> las preguntas ha contestado
                                <b>"SI"</b> entonces la tarea tiene un riesgo aceptable, o está en la
                                <b>ZONA VERDE</b>.
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#608E12">
                                Si
                                <b>una o más</b> respuestas son
                                <b>"NO"</b>, evalúe la tarea mediante los criterios de la norma ISO 11228'2.
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-form>
        <div class="text-xs-center" v-if="isotr112282!=null">
            <v-btn color="primary" @click="deleteForm" dark>Eliminar Registro</v-btn>
            <v-btn color="primary" @click="savePlibel" dark>Guardar</v-btn>
        </div>
        <v-dialog
                v-model="dialogError"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor verifique la información requerida para continuar.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogError = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogSuccess"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Se guardó con exito la información</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogSuccess = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import Isotr112282 from "../../../model/Isotr11228-2"
    import PatientMonitoring from "../../../model/PatientMonitoring";

    export default {
        data() {
            return {
                isotr112282: null,
                listIsotr112282: [],
                valid: true,
                search: '',
                dialogError: false,
                dialogSuccess: false,
            }
        },
        methods: {

            newPlibel() {
                let d = new Date();
                let e = this.formatDate(d);
                console.log(this.isotr112282)
                this.isotr112282 = new Isotr112282();
                console.log(this.isotr112282)
                this.isotr112282.fecha = e
                this.listIsotr112282.push(this.isotr112282)
            },
            savePlibel() {
                if (this.$refs.form.validate()) {
                    this.$store.state.patientMonitoringList = []
                    if (this.isotr112282.id != '' && this.isotr112282.id != null) {
                        this.$store.dispatch('getPatientMonitoring', this.isotr112282.id).then(response => {
                            this.$store.state.patientMonitoringOne.value = JSON.stringify(this.isotr112282)
                            this.$store.dispatch('updatePatientMonitoring', this.$store.state.patientMonitoringOne).then(response => {
                                this.dialogSuccess = true
                                this.reloadData()
                            }, error => {
                                this.$store.state.progress = false
                                this.$store.state.dialogError = true
                            })
                        })
                    } else {
                        let monitoringNew = new PatientMonitoring()
                        monitoringNew.date = new Date()
                        monitoringNew.value = JSON.stringify(this.isotr112282)
                        monitoringNew.form = 52
                        monitoringNew.patientRouteSheet = this.$store.state.routeSheet
                        this.$store.dispatch('addPatientMonitoring', monitoringNew).then(response => {
                            this.dialogSuccess = true
                            this.reloadData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }
                } else {
                    this.dialogError = true
                }
            },
            deleteForm(){
                confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deletePatientMonitoring',this.isotr112282.id).then(response => {
                    this.reloadData()
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            formatDate(date) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ":" + seconds + ' ' + ampm;
                return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            },
            reloadData() {
                let data = new PatientMonitoring()
                data.form = 52
                data.patientRouteSheet = this.$store.state.routeSheet
                data.date = new Date()
                data.value = ""
                this.isotr112282 = null
                this.$store.dispatch('getPatientMonitoringByRouteSheetForm', data).then(response => {
                    this.listIsotr112282 = []
                    for (let i = 0; i < this.$store.state.patientMonitoringList.length; i++) {
                        let anam = JSON.parse(this.$store.state.patientMonitoringList[i].value)
                        anam.id = this.$store.state.patientMonitoringList[i].id
                        this.listIsotr112282.push(anam)
                    }
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },

        },
        computed: {}
    }
</script>

<style scoped>
    v-switch {
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/patient/musculoEsqueletico/Isotr11228-2.vue